import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Variant = 'default' | 'secondary' | 'outline' | 'success' | 'warn' | 'destructive';

const VARIANT: Record<Variant, string> = {
  default: 'bg-primary/10 text-primary',
  secondary: 'bg-muted text-muted-foreground',
  outline: 'border text-foreground',
  success: 'bg-success/10 text-success',
  warn: 'bg-warning/15 text-warning',
  destructive: 'bg-destructive/10 text-destructive',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        VARIANT[variant],
        className,
      )}
      {...props}
    />
  );
}
